let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6HoYh")).then(() => parcelRequire('9w9df'));